module.exports = __webpack_public_path__ + "img/h10.56fade5d.jpg";